import { render, staticRenderFns } from "./Inventory.vue?vue&type=template&id=093acde9&scoped=true&"
import script from "./Inventory.vue?vue&type=script&lang=ts&"
export * from "./Inventory.vue?vue&type=script&lang=ts&"
import style0 from "./Inventory.vue?vue&type=style&index=0&id=093acde9&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093acde9",
  null
  
)

export default component.exports